
	import { defineComponent, PropType, ref } from 'vue'

	import Simplebar from '@/components/Simplebar.vue'
	import { ChannelPackInfo, usePackLineup } from '@/composables/useChannelPackInfo'

	export default defineComponent({
		components: {
			Simplebar,
		},

		props: {
			packInfo: {
				type: Object as PropType<ChannelPackInfo>,
				required: true,
			},
		},

		setup(props) {
			return {
				lineup: usePackLineup(props.packInfo.name),

				price: {
					dollar: Math.floor(props.packInfo.priceInCents / 100),
					cents: props.packInfo.priceInCents % 100,
				},

				controlStyles: {
					backgroundColor: props.packInfo.color,
					borderTopLeftRadius: '50% 1rem',
					borderTopRightRadius: '50% 1rem',
				},

				showingOverview: ref(true),
			}
		},
	})
